import * as React from 'react';
export const netbankingSvg = React.forwardRef(function netbankingSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M3.45 12.552H7.3V15H1V8.701h2.45v3.85ZM15 15H8.7v-2.448h3.852v-3.85H15V15Zm-4.9-4.898H5.902v-1.4h4.2v1.4ZM7.3 3.45H3.45v3.852H1V1h6.3v2.45Zm2.8 3.852H5.902v-1.4h4.2v1.4Zm4.9 0h-2.448V3.45H8.699V1H15v6.302Z',
    }),
  );
});
netbankingSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var netbanking = {
  category: 'paymentmethod',
  colorable: true,
  name: 'netbanking',
  svg: netbankingSvg,
};
